<template>
  <div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'OidcCallback',
  methods: {
    ...mapActions('oidcStore', [
      'oidcSignInCallback'
    ])
  },
  mounted () {
    this.oidcSignInCallback()
      .then((redirectPath) => {
        this.$log.info(`Received OIDC redirect to ${redirectPath}`)
        this.$router.push(redirectPath)
      })
      .catch((err) => {
        this.$log.error("Received OIDC error", err)
        this.$router.push('/oidc/error') // FIXME
      })
  }
}
</script>
